import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LOGOUT_EVENT } from 'mbs-ui-shared@tokens/logout.token';
import { Observable, shareReplay, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ConnectSettingsService {
  private http = inject(HttpClient);
  logoutEvent = inject<Subject<boolean>>(LOGOUT_EVENT);

  private connectClientUrl: Observable<string>;

  constructor() {
    const logoutEvent = this.logoutEvent;

    this.connectClientUrl = this.http
      .get<string>(`/api/build/connect-url`, { headers: { 'x-front-queue': 'true' } })
      .pipe(takeUntil(logoutEvent), shareReplay());
  }

  public getConnectClientBuild(): Observable<string> {
    return this.connectClientUrl;
  }
}
